import ShareInPostContainer from './ShareInPost.container';
import ShareInPost from './ShareInPost';
export default ShareInPostContainer(ShareInPost);
